import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TeamUserRolesEnum } from "@/enums/team-user-role";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamInvitationDTO } from "@shaarp/common";

export default function DataTableCellUserInvitationRole({
  invitation,
}: {
  invitation: TeamInvitationDTO;
}) {
  const { t } = useTranslation();

  return (
    <Select defaultValue="user" value={invitation.role} disabled={true}>
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={TeamUserRolesEnum.ADMIN} disabled className="hidden">
          {t("components.dataTableUsersInvitations.roles.administrator")}
        </SelectItem>
        <SelectItem value={TeamUserRolesEnum.MANAGER}>
          {t("components.dataTableUsersInvitations.roles.manager")}
        </SelectItem>
        <SelectItem value={TeamUserRolesEnum.MEMBER}>
          {t("components.dataTableUsersInvitations.roles.member")}
        </SelectItem>
        <SelectItem value={TeamUserRolesEnum.BILLING}>
          {t("components.dataTableUsersInvitations.roles.billing")}
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
